"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var FailedPaymentError_1 = require("../../ErrorPages/FailedPaymentError");
var InitPaymentError_1 = require("../../ErrorPages/InitPaymentError");
var OutOfStockPaymentError_1 = require("../../ErrorPages/OutOfStockPaymentError");
var TransactionErrorTypes_1 = require("../../../../../../common/enum/TransactionErrorTypes");
var webpayStyles_1 = require("./webpayStyles");
var MinimalLoader_1 = require("../../../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var react_intl_1 = require("react-intl");
var Webpay = function (_a) {
    var initError = _a.initError, loading = _a.loading, deal = _a.deal, softLocked = _a.softLocked;
    var _b;
    var styles = webpayStyles_1.default();
    var intl = react_intl_1.useIntl();
    if (loading) {
        return <MinimalLoader_1.default />;
    }
    if (initError) {
        if (softLocked) {
            return <OutOfStockPaymentError_1.default />;
        }
        return <InitPaymentError_1.default />;
    }
    if (!loading && ((_b = deal) === null || _b === void 0 ? void 0 : _b.status) === TransactionErrorTypes_1.TransactionErrorTypes.FAILED) {
        return <FailedPaymentError_1.default />;
    }
    return (<>
      <core_1.Typography variant="subtitle1" className={styles.title}>
        <Translation_1.default id="trans__checkout__payment_page__subtitle"/>
      </core_1.Typography>
      <core_1.Typography variant="subtitle2">
        <Translation_1.default className={styles.description} id="trans__checkout__payment_page__description1"/>
      </core_1.Typography>
      <core_1.Typography variant="subtitle1" className={styles.description2}>
        <Translation_1.default id="trans__checkout__payment_page__description2" values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__payment_page__email',
        })}>
                <Translation_1.default id={'trans__checkout__payment_page__email'}/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = Webpay;
